import React from 'react';

import './styles.css';

import Spreader from '../Spreader';
import Tahometer from './Tahometer';
import Story from './Story';
import Appearance from '../Appearance';
import TextBlock from '../TextBlock';

export default props => {
  return (
    <div className="SpeedTest" style={props.style}>
      <Spreader>
        <Appearance type="up">
          <div className="SpeedTest__text">
            Предлагаем вам небольшой эксперимент, в котором вы можете измерить и
            наглядно сравнить вашу текущую скорость интернет-подключения с той,
            которая будет при 5G
          </div>
        </Appearance>
        <div className="SpeedTest__inner">
          <Tahometer className="SpeedTest__tahometer" />
          <Story className="SpeedTest__story" />
        </div>
      </Spreader>
    </div>
  );
};

// <div className="SpeedTest__title">Мы меняем городскую среду</div>
